import { useConfigStore } from '~/store/useConfigStore'

export const useDarkTheme = () => {
  const { info } = console
  const config = useConfigStore()
  const init = () => {
    const { darkTheme, websiteLayout } = config.$state

    if (!darkTheme) {
      return
    }

    info(websiteLayout)

    if (websiteLayout === 'dark') {
      useHead({
        htmlAttrs: {
          style: `
            --base-background-color: ${darkTheme?.baseBackgroundColor};
            --light-background-color: ${darkTheme?.lightBackgroundColor};
            --dark-background-color: ${darkTheme?.darkBackgroundColor};
            --text-dark-color: ${darkTheme?.textDarkColor};
            --text-light-color: ${darkTheme?.textLightColor};
          `,
        },
      })
    }
  }

  init()

  return {
    init,
  }
}
